import { render, staticRenderFns } from "./PresaleForm.vue?vue&type=template&id=37781686&"
import script from "./PresaleForm.vue?vue&type=script&lang=js&"
export * from "./PresaleForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports